import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import BackupModal from "@/components/BackupModal";
import TrendsChart from "@/components/TrendsChart";
import UpcomingEvents from "@/components/UpcomingEvents";
import { Table2, Receipt, Users, FileBarChart2, DatabaseBackup } from "lucide-react";
import { Link } from "react-router-dom";
import { BACKUP, DASHBOARD } from "@/constants/testIds";

const TILES = [
  {
    to: "/captura",
    icon: Table2,
    title: "Captura Masiva",
    desc: "Ofrendas, diezmos y asistencia semanal",
  },
  {
    to: "/gastos",
    icon: Receipt,
    title: "Gastos",
    desc: "Registro de salidas por categoría",
  },
  {
    to: "/miembros",
    icon: Users,
    title: "Miembros",
    desc: "Directorio y ministerios",
  },
  {
    to: "/reportes",
    icon: FileBarChart2,
    title: "Reportes",
    desc: "Mensual, sobres, miembros y balance anual",
  },
];

export default function Dashboard() {
  const [backupOpen, setBackupOpen] = useState(false);

  return (
    <div data-testid={DASHBOARD.page}>
      <PageHeader
        title="Panel Administrativo"
        subtitle="Resumen general del sistema AJAR"
        actions={
          <button
            data-testid={BACKUP.openButton}
            onClick={() => setBackupOpen(true)}
            className="inline-flex items-center gap-2 bg-white border border-[#c8a04a] text-[#7a5b0f] hover:bg-[#fdf7e1] px-4 py-2.5 text-xs uppercase tracking-widest"
          >
            <DatabaseBackup size={14} /> Respaldo
          </button>
        }
      />
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {TILES.map(({ to, icon: Icon, title, desc }) => (
          <Link
            key={to}
            to={to}
            className="group bg-white border border-[#d9cfb8] p-6 hover:border-[#c8a04a] transition shadow-[0_2px_0_#ece4cf]"
            style={{ borderTop: "3px solid #c8a04a" }}
          >
            <div className="w-10 h-10 rounded bg-[#1c2a3a] text-[#e7c879] flex items-center justify-center mb-4 group-hover:bg-[#0f1a2c]">
              <Icon size={18} />
            </div>
            <div className="font-serif text-xl text-[#1c1a14]">{title}</div>
            <div className="text-sm text-[#5d5849] mt-2">{desc}</div>
          </Link>
        ))}
      </div>

      <div className="px-8 pb-12 space-y-6">
        <UpcomingEvents />
        <TrendsChart />
        <div className="bg-white border border-[#d9cfb8] p-8" style={{ borderTop: "3px solid #c8a04a" }}>
          <div className="text-xs uppercase tracking-widest text-[#8b7e5e] mb-2">
            Sistema AJAR
          </div>
          <h2 className="font-serif text-2xl text-[#1c1a14] mb-2">
            Ministerios Árboles Junto al Río
          </h2>
          <p className="text-sm text-[#5d5849] max-w-2xl leading-relaxed">
            Captura semanal de ofrendas, diezmos, ofrendas especiales y asistencia con
            la misma estructura tipo hoja de cálculo. Genera reportes mensuales,
            individuales por miembro y balance anual con exportación a PDF.
          </p>
        </div>
      </div>

      <BackupModal open={backupOpen} onClose={() => setBackupOpen(false)} />
    </div>
  );
}
